export enum PreviousStudyDepartment {
	SbaOversight = "sba-oversight",
	FollowUp = "follow-up",
	Investigation = "investigation",
	Prosecution = "prosecution",
}
